// extracted by mini-css-extract-plugin
export default {"catalogByServiceItem":"c-l_fn","catalogByServiceItem__title":"c-l_fo"};